export default __webpack_public_path__ + "static/favicon-128-99ae2d793d3d1f31646e9bced43c1299.png";